export default __webpack_public_path__ + "static/media/gallery-img-1.0441ee10.png";